import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes } from '@angular/router';

import { IonicModule } from '@ionic/angular';
import { PipesModule } from 'src/app/shared/pipes/pipes.module';
import { JobFollowUpComponent } from "src/app/shared/modals/job-follow-up/job-follow-up.component";
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';

const routes: Routes = [
    {
        path: '',
        component: JobFollowUpComponent
    }
];

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        PipesModule,
        MatTooltipModule
    ],
    declarations: [JobFollowUpComponent],
    exports: [JobFollowUpComponent]
})
export class JobFollowUpModule {
}
